<template>
  <v-flex column wrap justify-center class="container">
    <text-field v-model="form.submitNote" :validator="vs.submitNote" :label="adminText('workflowsAll.submit_note_947bc8a', 'Submit note')" />
    <textarea-field v-model="form.submitInfo" :validator="vs.submitInfo" :label="adminText('workflowsAll.submit_info_5b11aaa', 'Submit info')" />
  </v-flex>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
export default {
  mixins: [WorkflowDisplay],
  name: 'register-form',
  props: {
    initialValues: {
      type: Object,
      default: () => {},
    },
    vs: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      form: {
        submitNote: this.$t('submitNote'),
        submitInfo: this.$t('submitNoteDescription'),
      },
    }
  },
  watch: {
    form: {
      handler(val) {
        this.$emit('values', val)
      },
      deep: true,
    },
  },
  mounted() {
    if (this.initialValues && Object.keys(this.initialValues).length) {
      this.form = { ...this.form, ...this.initialValues }
    }
    this.$emit('values', this.form)
  },
}
</script>

<style scoped>
.container {
  max-width: 672px;
  margin: 0px;
  padding-left: 0px;
  padding-right: 0px;
}
</style>
